// library imports
import * as Constants from "_core/configs/Constants";
import { getTime, FormatDateCompactJst } from "_core/utils/common";

/**
 * ユーザープロンプト（追加参照ファイル）ダウンロード API
 * バイナリレスポンスを受け取りそのままファイル保存するため、
 * 共通 ApiRequest (JSON前提) は使用せず fetch を直接使用する。
 */
const AdminDownloadUserPromptApi = () => {
    const url = "/admin/download_user_prompt";

    const ExecAdminDownloadUserPromptApi = async () => {
        try {
            const nowTime = getTime();

            const params = new URLSearchParams();
            params.append("api_timestamp", nowTime);
            params.append("is_editor", true);

            const response = await fetch(Constants.BASE_URL + url, {
                mode: "cors",
                method: "POST",
                credentials: "include",
                headers: {
                    accept: "*/*",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: params.toString(),
            });

            if (!response.ok) {
                throw new Error(`Download failed: ${response.status}`);
            }

            const contentType = response.headers.get("content-type");
            if (contentType?.includes("application/json")) {
                const responseJson = await response.json();
                if (responseJson.error_code && responseJson.error_code > 0) {
                    return { error: responseJson.error_detail }
                }
            }

            // Content-Disposition はクロスオリジンでは読めないことがあるため、同じ規則のファイル名を用意しておく
            const disposition = response.headers.get("Content-Disposition") || "";
            const rfc5987Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            const filename = rfc5987Match
                ? decodeURIComponent(rfc5987Match[1])
                : `追加参照ファイル_${FormatDateCompactJst()}.txt`;

            // Blob に変換してブラウザダウンロードをトリガー
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = objectUrl;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(objectUrl);

            return { error: null };
        } catch (e) {
            const result = {
                "code": 900000,
                "title": "エラー",
                "message": Constants.UNKNOWN_ERROR_DETAIL,
                "event": 0,
                "value": ""
            }
            return { error: result };
        }
    };

    return ExecAdminDownloadUserPromptApi;
};

export default AdminDownloadUserPromptApi;
